import * as privacyReminder from '../../browser/browserApp/privacyReminder';
import renderAnnouncementBox from './renderAnnouncementBox';
import * as siteMenu from './siteMenu';

declare var window: any;

window.mk__common__common = {
    renderAnnouncementBox,
    siteMenu,
    privacyReminder,
};
